import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Storage } from '@/tscapi/utils/browser-storage';
import { Cookie } from '@/tscapi/utils/cookie';

export interface LanguageToggleProps {
    isQuebec: boolean;
    setIsQuebec: any;
}

export const LanguageToggle = ({ isQuebec, setIsQuebec }: LanguageToggleProps) => {
    const { t, i18n } = useTranslation();
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <>
            {isQuebec && (
                <>
                    <span className="footer__separater">|</span>
                    <a
                        href="/"
                        className="footer__links"
                        onClick={(e) => {
                            e.preventDefault();
                            const cookie = new Cookie();
                            cookie.Language = 'en_CA';
                            changeLanguage('en');
                            setIsQuebec(false);
                        }}
                    >
                        {t('Langue - English')}
                    </a>
                </>
            )}
        </>
    );
};
